// extracted by mini-css-extract-plugin
export var callCard = "_mk-0";
export var callMessageButton = "_mk-1";
export var helpIcon = "_mk-3";
export var helpIconContainer = "_mk-4";
export var verticalDivider = "_mk-2";